import { useState, useEffect } from "react";

export const useBlogPosts = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/articles.php")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setBlogPosts(data);
          return;
        }
        if (data && data.success && Array.isArray(data.data)) {
          setBlogPosts(data.data);
          return;
        }
        console.warn("Ungültige Blogdaten erhalten", data);
      })
      .catch((err) => console.error("Blogdaten konnten nicht geladen werden:", err))
      .finally(() => setLoading(false));
  }, []);

  return { blogPosts, loading };
};
